import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "../Styles/style.css";
import { LogOutModel } from "./LogOutModel";
import UserWhite from "../Images/profile-image.png";
import ProfileIcon from "../assets/img/profile-icon1.png";
import ProfileIcon2 from "../assets/img/profile-icon2.png";
import LogoutIcon from "../assets/img/logout.png";
import ProfileIcon4 from "../assets/img/profile-icon4.png"
import ProfileService from "../Services/Profile";
import i18n, { _get_i18Lang } from "../i18n";
import { useUser } from "../Contexts/UserContext";

const ProfileSidePanel =
  ({ color,
    ImageOfUser
  }: {
    color: string,
    ImageOfUser: any
  }) => {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
    const [image, setImage] = useState<any>(null);

    const { userImg } = useUser();

    const UserIdentity = localStorage.getItem("UserId") as string;
    // const ProfilePic = localStorage.getItem("Image")

    const handleCloseDialog = () => {
      setIsDialogOpen(false);
    };

    // useEffect(() => {
    //   const fetchData = async () => {
    //     try {
    //       if (!UserIdentity) return;
    //       const response = await ProfileService.getProfile(_get_i18Lang())
    //       const res = await response;

    //       // setUserImg(res.result.imagePath)
    //     } catch (error) {
    //       console.error("Error fetching data:", error);
    //     } finally {
    //       // setLoading(false); // Hide loader after fetching
    //     }
    //   }
    //   fetchData();
    // }, [i18n.language]);
    let UserName = localStorage.getItem("UserName")

    return (
      <div className="col-lg-3">
        <div
          style={{
            backgroundColor: "#FFFAF0",
            padding: "16px",
            boxShadow: "0 0 7px 1px #f5deb1",
            height: "100%",
          }}
        >
          <div
            style={{
              textAlign: "center",
              backgroundColor: "#fb8c1c",
              padding: "7px",
              borderRadius: "2px",
            }}
          >
            {UserIdentity ? (
              <img
                id="userimg"
                src={userImg === "" ? UserWhite : userImg}
                title="User Image"
                alt="user"
                style={{ width: "200px", height: "200px" }}
                onError={() => ("https://gitaseva.org/assets/img/profile-image1.png")}
              />
            ) : (
              <img
                id="userimg"
                src={ProfileIcon}
                title="User Image"
                className="nousericon"
                alt="user"
                style={{ width: "200px", height: "200px" }}
              />
            )}
            <h6
              style={{
                fontFamily: "ChanakyaUni",
                color: "#fffaf0",
                margin: "15px 0 -5px",
                fontSize: "21px",
              }}
            >
              {UserName}
            </h6>
          </div>
          <div>
            <ul
              style={{
                listStyleType: "none",
              }}
            >
              <li
                style={{
                  display: "flex",
                  padding: "0 16px",
                  marginTop: "30px",
                }}
              >
                <img
                  src={ProfileIcon}
                  alt="profile"
                  style={{
                    height: "19px",
                    width: "16px",
                    marginTop: "5px",
                  }}
                />
                <div
                  style={{
                    cursor: "pointer",
                    color:
                      window.location.pathname === `/profile`
                        ? "#FF9800"
                        : "#472D1E",
                    fontSize: "21px",
                    fontFamily: "ChanakyaUni",
                    padding: "0 16px",
                    fontWeight: 600,
                  }}
                  onClick={() => {
                    navigate(`/profile`);
                  }}
                >
                  {t("Profile_tr")}
                </div>
              </li>
            </ul>
          </div>

          <div>
            <ul
              style={{
                listStyleType: "none",
                borderTop: "1px solid rgb(245, 220, 160)",
              }}
            >
              <li
                style={{
                  display: "flex",
                  padding: "0 16px",
                  marginTop: "15px",
                }}
              >
                <img
                  src={ProfileIcon2}
                  alt="profile"
                  style={{
                    height: "19px",
                    width: "16px",
                    marginTop: "2px",
                  }}
                />
                <div
                  style={{
                    cursor: "pointer",
                    color:
                      window.location.pathname === `/profile/My-Favourites`
                        ? "#FF9800"
                        : "#472D1E",
                    //   color: "#472D1E",
                    fontSize: "21px",
                    fontFamily: "ChanakyaUni",
                    padding: "0 16px",
                    fontWeight: 600,
                  }}
                  onClick={() => {
                    navigate(`/profile/My-Favourites`);
                  }}
                >
                  {t("Favourite_tr")}
                </div>
              </li>
            </ul>
          </div>

          <div>
            <ul
              style={{
                listStyleType: "none",
                borderTop: "1px solid rgb(245, 220, 160)",
              }}
            >
              <li
                style={{
                  display: "flex",
                  padding: "0 16px",
                  marginTop: "15px",
                }}
              >
                <img
                  src={ProfileIcon4}
                  alt="profile"
                  style={{
                    height: "19px",
                    width: "16px",
                    marginTop: "5px",
                  }}
                />
                <div
                  style={{
                    cursor: "pointer",
                    color:
                      window.location.pathname === `/profile/feedback`
                        ? "#FF9800"
                        : "#472D1E",
                    //   color: "#472D1E",
                    fontSize: "21px",
                    fontFamily: "ChanakyaUni",
                    padding: "0 16px",
                    fontWeight: 600,
                  }}
                  onClick={() => {
                    navigate(`/profile/feedback`);
                  }}
                >
                  {t("Help_tr")}
                </div>
              </li>
            </ul>
          </div>

          <div>
            <ul
              style={{
                listStyleType: "none",
                borderTop: "1px solid rgb(245, 220, 160)",
              }}
            >
              <li
                style={{
                  display: "flex",
                  padding: "0 16px",
                  marginTop: "15px",
                }}
              >
                <img
                  src={LogoutIcon}
                  alt="profile"
                  style={{
                    height: "19px",
                    width: "16px",
                    marginTop: "5px",
                  }}
                />
                <div
                  style={{
                    cursor: "pointer",
                    color: "#472D1E",
                    fontSize: "21px",
                    padding: "0 16px",
                    fontWeight: 600,
                  }}
                  onClick={() => {
                    setIsDialogOpen(true);
                  }}
                >
                  {t("LogOut_tr")}
                </div>
              </li>
            </ul>
          </div>
          <LogOutModel open={isDialogOpen} onClose={handleCloseDialog} />
        </div>
      </div>
    );
  };
export default ProfileSidePanel;
